<app-loader *ngIf="loaderIcon | async"></app-loader>
<!-- Modal Overlay -->
<div class="modal" *ngIf="!voidPayment">

  <div class="modal-dialog" (click)="$event.stopPropagation()">
    <div class="modal-content" *ngIf="keyedInTransaction">
      <div class="modal-header">
        <h5 class="modal-title">{{paymentModeText}}</h5>
        <label class="lblPaymentAmt">Amount: {{CurrencyCCAmount}}</label>
      </div>

      <div class="modal-body">
        <form id="payment-form">
          <div id="payment-element"></div>
          <div id="address-element"></div>
          <button id="submit" style="display: none;">
            <div class="spinner hidden" id="spinner"></div>
            <span id="button-text">Pay</span>
          </button>
          <div id="payment-message" class="hidden"></div>
        </form>
      </div>

      <div class="modal-footer">
        <!--<div *ngIf="!isAchOrEftPayment()">-->
        <div *ngIf="isMandatoryAddressField()">
          <label class="pure-material-checkbox float-left">
            <input type="checkbox" class="checkBoxClass"
                   (change)="onClickAutoPopulateBillingInfo($event.target.checked)">
            <span class="charitypay_text mt-0">{{AutoPopulateBillingInfoMsg}}</span>
          </label>
        </div>

        <div class="pay_rgt_butt">
          <div *ngIf="!isEftPayment()">
            <button type="button" class="btn btn-orange me-1" (click)="onhstPayBtn('Cancel')">Cancel</button>
            <button (click)="onStripePay()" class="btn btn-primary">{{submitButtonName}}</button>
          </div>
        </div>
      </div>
    </div>
    <!--for terminal device-->
    <div id="TerminalDevice" class="modal-content" *ngIf="!keyedInTransaction && CountdownS > 0">
      <div class="modal-header">
        <h5 class="modal-title">{{paymentModeText}}</h5>
        <label class="lblPaymentAmt">Amount: {{CurrencyCCAmount}}</label>
      </div>
      <div class="modal-body">
        <!-- Main Text -->
        <h4 class="fw-bold">Transaction is in Progress</h4>
        <p class="text-muted">Please do not leave or refresh the page!</p>
        <br />
        <p>Please complete the transaction before - {{ paymentCountdown }}</p>
      </div>
      <div class="modal-footer">
        <div class="pay_rgt_butt">
          <button type="button" class="btn btn-orange me-1" (click)="onhstPayBtn('Cancel')">Cancel</button>
        </div>
      </div>
    </div>
  </div>
</div>
